import { render } from "./PreLoginPage.vue?vue&type=template&id=0abe3c40&ts=true"
import script from "./PreLoginPage.vue?vue&type=script&lang=ts"
export * from "./PreLoginPage.vue?vue&type=script&lang=ts"

import "./PreLoginPage.vue?vue&type=style&index=0&id=0abe3c40&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__